import { useEffect, useState } from "react";
import {
  BlueBirdTheme, Button, Divider, Filter, SearchBar,
} from "@kitbird/core";
import Summary from "../../../../../components/Summary";
import { CustomDatePicker, DatePickerWrapper } from "../../../../../components/CustomDatePicker.style";
import FilterDropdown from "../../../../../components/FilterDropdown";
import { ReactComponent as DownloadIcon } from "../../../../../assets/icons/download_icon.svg";
import { IOptionItem } from "../../../../../typings/common";
import useReportReceiptSubmission from "../../useReportReceiptSubmission";
import { listDepartmentAll, listPoolAll } from "../../../CreateReceiptSubmission/constants";
import useAuth from "../../../../../components/Authentication/useAuth";
import { ReactComponent as FilterIcon } from "../../../../../assets/icons/filter.svg";
import SearchInput from "../../../../../components/SearchInput";
import { ActionSection } from "../../../../../components/Filter/Filter.style";

interface FilterSectionI {
  useCustomHook: ReturnType<typeof useReportReceiptSubmission>,
}

const { primary, white } = BlueBirdTheme.colors;

export default function FilterSection({
  useCustomHook,
}: FilterSectionI) {
  const { userAccount } = useAuth();
  const {
    params,
    setParams,
    searchText,
    setSearchText,
    selectedTrxs,
    dataMasterDepartment,
    summary,
    columnOpts,
    setColumnOpts,
  } = useCustomHook;

  return (
    <>
      <div style={{
        display: "flex", gap: 16, width: "100%",
      }}>
        <Summary type="primary" title="Total bon" amount={summary.total_bon_amount} />
        <Summary type="warning" title="Bon terbesar" amount={summary.bon_amount_terbesar} />
        <Summary type="success" title="Bon terkecil" amount={summary.bon_amount_terkecil} />
      </div>
      <Divider color={primary[200]} />
      <ActionSection>
        <ActionSection style={{ justifyContent: "unset" }}>
          <SearchInput
            placeholder="Cari data"
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
          />
          <DatePickerWrapper>
            <CustomDatePicker
              variant="withRange"
              label="Tanggal"
              startDate={params.dates ? params.dates[0] : undefined}
              endDate={params.dates ? params.dates[1] : undefined}
              onChange={() => { /* */ }}
              onReset={() => setParams((curr) => ({ ...curr, dates: undefined }))}
              onSubmit={(dates: Date[] | null) => {
                setParams((curr) => ({ ...curr, dates: dates || undefined }));
              }}
            />
          </DatePickerWrapper>
          <FilterDropdown
            id="pool"
            label="Pool"
            value={params.pool?.label}
            onSelected={(val: IOptionItem) => setParams(
              (curr) => ({
                ...curr,
                pool: val as { label: string, value: string },
              }),
            )}
            options={userAccount.userPools.map((pool) => (
              { label: pool.poolName, value: pool.poolId }
            ))}
          />
          <FilterDropdown
            id="department"
            label="Departemen"
            value={params.department?.label}
            onSelected={(val: IOptionItem) => setParams(
              (curr) => ({
                ...curr,
                department: val as { label: string, value: string },
              }),
            )}
            options={[
              { label: "Semua departemen", value: "" },
              ...((dataMasterDepartment?.lstmstdepartment || listDepartmentAll)
                .map((department) => (
                  { label: department.department, value: department.department }
                )) || [])]}
          />
        </ActionSection>
        <Filter
          label="&nbsp;&nbsp;&nbsp;Kolom"
          icon={<FilterIcon />}
          options={columnOpts}
          onSelected={setColumnOpts}
        />
      </ActionSection>
    </>
  );
}
